import { FormGroup } from "@blueprintjs/core";
import { observer } from "mobx-react";
import * as React from "react";
import IntlCurrencyInput from "react-intl-currency-input";
import { MDBCol, MDBRow } from "mdbreact";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import CnpjInput from "../utils/CnpjInput";
const numeral = require("numeral");

interface CalculadoraPageProps {
}

interface CalculadoraPageState {
}

@observer
export class CalculadoraPage extends React.Component<CalculadoraPageProps, CalculadoraPageState> {

    constructor(props: any) {
        super(props);
    }

    handlePlano = (faixa: any) => {

        EmpresaStore.obs.valorPlano = faixa.faixa;

        EmpresaStore.obs.plano = faixa;

    };

    handleClick = () => {

      window.open(`https://api.whatsapp.com/send?phone=54920004300&text=Ol%C3%A1!%20Gostaria%20de%20saber%20mais%20sobre%20os%20planos%20personalizados%20para%20empresas%20com%20rendimentos%20superiores%20a%2010%20milh%C3%B5es.`, '_blank');

    };

    handleBlocoPlano() {

        const faixasPlanos = [
            { faixa: 1, maximo: 100000, minimo: 0, valor: 19.9, armazenamento: 200 },
            { faixa: 2, maximo: 360000, minimo: 100000, valor: 29.9, armazenamento: 300 },
            { faixa: 3, maximo: 720000, minimo: 360000, valor: 49.9, armazenamento: 400 },
            { faixa: 4, maximo: 1800000, minimo: 720000, valor: 69.9, armazenamento: 500 },
            { faixa: 5, maximo: 3600000, minimo: 1800000, valor: 99.9, armazenamento: 800 },
            { faixa: 6, maximo: 4800000, minimo: 3600000, valor: 199.9, armazenamento: 1024 },
            { faixa: 7, maximo: 4980000, minimo: 4800000, valor: 229.9, armazenamento: 1024 },
            { faixa: 8, maximo: 5160000, minimo: 4980000, valor: 249.9, armazenamento: 1024 },
            { faixa: 9, maximo: 5520000, minimo: 5160000, valor: 269.9, armazenamento: 1024 },
            { faixa: 10, maximo: 6600000, minimo: 5520000, valor: 299.9, armazenamento: 1024 },
            { faixa: 11, maximo: 7800000, minimo: 6600000, valor: 399.9, armazenamento: 2048 },
            { faixa: 12, maximo: 9000000, minimo: 7800000, valor: 499.9, armazenamento: 2048 },
            { faixa: 13, maximo: 10000000, minimo: 9000000, valor: 699.9, armazenamento: 2048 },
        ];

        let planoSelecionado = faixasPlanos.find(faixa => EmpresaStore.obs.rendimento_mensal <= faixa.maximo);

        let maximo: number = 10000000
        let faixa = 13
        let armazenamento = 2048

        if (!planoSelecionado) {

            while (EmpresaStore.obs.rendimento_mensal > maximo) {

                faixa += 1
                armazenamento += 1024
                maximo += 5000000;

            }

            let valor = maximo * 0.0001109;

            planoSelecionado = { faixa: faixa, maximo: maximo, minimo: maximo - 5000000, valor: valor, armazenamento: armazenamento }

        }

        EmpresaStore.obs.valorPlano = planoSelecionado.faixa

        EmpresaStore.obs.plano = planoSelecionado

        return (
            <>
              {EmpresaStore.obs.rendimento_mensal > 10000000 ?

                <MDBRow>
                  <MDBCol md="12">
                    <div className="blocoAssin blocoCreatePlan">
                      <span className="descAssinPerfil">&nbsp;</span>
                      <span className="priceAssinPerfil">A definir</span>
                      <span className="periodoAssinPerfil">/ mês</span>
                      <span className="descAssinPerfil">
                        Empresas com rendimentos superiores a 10 milhões devem entrar em contato com o suporte para mais informações e personalização do plano.<br /><br />
                        {`Até ${numeral(planoSelecionado.maximo).format('$ 0,0.00')} de valor calculado`} <br />
                        {`${numeral(planoSelecionado.armazenamento * 1000000).format("0 b")} de armazenamento`} <br />
                      </span>
                      <button
                        className="countAssinPerfil active5"
                        onClick={() => this.handleClick()}
                      >
                        Contatar
                      </button>
                    </div>
                  </MDBCol>
                </MDBRow>

                :

                <MDBRow>
                    <MDBCol md="12">
                        <div className="blocoAssin blocoCreatePlan">
                            <span className="descAssinPerfil">{`${planoSelecionado.faixa}ª Faixa`}</span>
                            <span className="priceAssinPerfil">{numeral(planoSelecionado.valor).format('$ 0,0.00')}</span>
                            <span className="periodoAssinPerfil">/ mês</span>
                            <span className="descAssinPerfil">
                                {`Até ${numeral(planoSelecionado.maximo).format('$ 0,0.00')} de valor calculado`} <br />{" "}
                                {`${numeral(planoSelecionado.armazenamento * 1000000).format("0 b")} de armazenamento`} <br />{" "}
                            </span>
                            <button
                                disabled={EmpresaStore.obs.buscando_cnpj}
                                className={"countAssinPerfil active5"}
                                onClick={() => this.handlePlano(planoSelecionado)}
                            >
                                {"Selecionado"}
                            </button>
                        </div>
                    </MDBCol>
                </MDBRow>

                    }
                    
            </>
        );
    }

    render() {

        const currencyConfig = {
            locale: "pt-BR",
            formats: {
                number: {
                    BRL: {
                        style: "currency",
                        currency: "BRL",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    },
                },
            },
        };

        const hanldeRendimento = (event, value, maskedValue) => {
            EmpresaStore.obs.rendimento_mensal = value
        }

        return (<>

            <FormGroup>
                <label className="bp3-label">
                    Rendimento Mensal
                </label>
                <IntlCurrencyInput
                    className="form-control"
                    onChange={hanldeRendimento}
                    value={EmpresaStore.obs.rendimento_mensal}
                    currency="BRL"
                    config={currencyConfig}
                />
            </FormGroup>

            <FormGroup
                label="Digite o CNPJ da Empresa"
                labelFor="cnpj"
                style={{ width: "100%" }}
            >
                <CnpjInput
                    onChange={val => EmpresaStore.obs.cnpj = val}
                    value={EmpresaStore.obs.cnpj}
                    disabled={true}
                />
            </FormGroup>

            {this.handleBlocoPlano()}

        </>)
    }
}

export default CalculadoraPage;
